import React, { ReactNode } from 'react';
import './AppShell.css';

export interface PageHeaderProps {
  title: string;
  meta?: ReactNode;
  actions?: ReactNode;
}

const PageHeader: React.FC<PageHeaderProps> = ({ title, meta, actions }) => {
  return (
    <div className="shell-page-header">
      <div className="shell-page-header__left">
        <h1 className="shell-page-header__title">{title}</h1>
        {meta && <div className="shell-page-header__meta" data-testid="page-header-meta">{meta}</div>}
      </div>
      {actions && <div className="shell-page-header__actions">{actions}</div>}
    </div>
  );
};

export default PageHeader;
